"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarSelection = void 0;
const react_1 = __importDefault(require("react"));
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const react_native_1 = require("react-native");
const design_player_avatar_1 = require("@unboared/design.player.avatar");
const utils_1 = require("./utils");
const AvatarSelection = ({ current, setAvatar, color, generator, size = design_player_avatar_1.DEFAULT_AVATAR_SIZE }) => {
    const mainTheme = (0, rn_css_1.useTheme)();
    let currentTheme = mainTheme || base_ui_theme_themes_1.defaultTheme;
    const generatorFn = generator || utils_1.sampleAvatar;
    const currentAvatar = current || generatorFn();
    const callUpdate = () => {
        let newAvatar = generatorFn();
        if (newAvatar !== currentAvatar) {
            setAvatar(newAvatar);
        }
        else {
            callUpdate();
        }
    };
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: callUpdate },
        react_1.default.createElement(design_player_avatar_1.Avatar, { name: currentAvatar, color: color || currentTheme.color.primary, size: size })));
};
exports.AvatarSelection = AvatarSelection;
//# sourceMappingURL=avatar_selection.js.map